var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/CrossCircle.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const CrossCircle = ({
  color = '#fff',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 5.576 5.576 2 10 2C14.424 2 18 5.576 18 10C18 14.424 14.424 18 10 18C5.576 18 2 14.424 2 10ZM9.99997 8.58996L11.89 6.69996C12.27 6.31996 12.91 6.31996 13.3 6.69996C13.69 7.08996 13.69 7.71996 13.3 8.10996L11.41 9.99996L13.3 11.89C13.69 12.28 13.69 12.91 13.3 13.3C12.91 13.69 12.28 13.69 11.89 13.3L9.99997 11.41L8.10997 13.3C7.71997 13.69 7.08997 13.69 6.69997 13.3C6.30997 12.91 6.30997 12.28 6.69997 11.89L8.58997 9.99996L6.69997 8.10996C6.30997 7.71996 6.30997 7.08996 6.69997 6.69996C6.8868 6.5127 7.14045 6.40747 7.40497 6.40747C7.66949 6.40747 7.92314 6.5127 8.10997 6.69996L9.99997 8.58996Z",
    fill: color
  })
});